export const FETCH_CCS_ANALYSIS_ENROLLMENT_RATE = "FETCH_CCS_ANALYSIS_ENROLLMENT_RATE";
export const SET_CCS_ANALYSIS_ENROLLMENT_RATE = "SET_CCS_ANALYSIS_ENROLLMENT_RATE";

export const FETCH_CCS_ANALYSIS_USER_ENGAGEMENT_RATE = "FETCH_CCS_ANALYSIS_USER_ENGAGEMENT_RATE";
export const SET_CCS_ANALYSIS_USER_ENGAGEMENT_RATE = "SET_CCS_ANALYSIS_USER_ENGAGEMENT_RATE";
